import { createContext, Dispatch, SetStateAction } from 'react';

import { FileToDownload } from '~src/utils/download';

export interface LargeFilesCtx {
  largeFilesContext: FileToDownload[];
  setLargeFilesContext: Dispatch<
    SetStateAction<LargeFilesCtx['largeFilesContext']>
  >;
}

/**
 * Holds large files filtered out of folder/multi download
 */
const LargeFilesContext = createContext({
  largeFilesContext: [],
  setLargeFilesContext: () => [],
} as LargeFilesCtx);

export default LargeFilesContext;
